import useViewModel from './viewModel';
import Header from 'components/Layout/Header';
import {
  Wrapper,
  PaymentSectionLayout,
  SplitBillWaitingTitleContainer,
  Title,
  SubTitle,
  TotalSpiltBill,
  TotalSpiltAmount,
  PaymentRemainTitle,
  QrIcon,
  ShareQrCodeContainer,
  ShareQrCodeDialog,
} from './index.view';

import { currencyFormat } from 'utils/number';
import ShareQrCode from './component/ShareQrCode';
import { useTranslation } from 'react-i18next';
import FullPageSpinner, { LoadingIcon } from 'components/FullPageSpinner';
import { useHistory } from 'react-router-dom';
import TransferModal from 'pages/SplitBill/Waiting/component/Transfer';
import { PAYMENT_TYPE } from 'constants/enum/type';
import { PayOther } from './component/PayOther';

const SplitBillWaiting = () => {
  const { handleClose, open, handleOpen, remaining, paymentInfo, transfer, confirming, allPaid } =
    useViewModel();
  const { type } = paymentInfo;
  const history = useHistory();
  const state = history.location.state;

  const { t } = useTranslation();

  return !remaining ? (
    <FullPageSpinner />
  ) : (
    <Wrapper id="wrapper-scroll-hook">
      <TransferModal state={state} transfer={transfer} />
      <Header />
      <SplitBillWaitingTitleContainer>
        <Title>{t('splitBillWaitingTitle')}</Title>
        <SubTitle>
          {t('splitBillWaitingSubTitle', { count: remaining?.count, total: remaining?.total })}
        </SubTitle>
      </SplitBillWaitingTitleContainer>
      <ShareQrCodeDialog open={open} dividers={false} handleClose={handleClose}>
        <ShareQrCode total={remaining?.total} type={type} />
      </ShareQrCodeDialog>
      <PaymentSectionLayout>
        <div className="circle">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            style={{ display: 'none' }}
          >
            <symbol id="wave">
              <path d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z"></path>
              <path d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z"></path>
              <path d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z"></path>
              <path d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z"></path>
            </symbol>
          </svg>
          <div className="box">
            <div className="percent">
              {allPaid ? (
                <>
                  <TotalSpiltBill bold>{t('allPaid')}</TotalSpiltBill>
                  <PaymentRemainTitle>{t('splitBillWaitingPaymentSuccess')}</PaymentRemainTitle>
                  {confirming && <LoadingIcon />}
                </>
              ) : (
                <>
                  <TotalSpiltBill>
                    {remaining?.count} / {remaining?.total}
                  </TotalSpiltBill>
                  <TotalSpiltAmount>{currencyFormat(remaining?.amount)}</TotalSpiltAmount>
                  <PaymentRemainTitle>{t('splitBillWaitingPaymentRemain')}</PaymentRemainTitle>
                </>
              )}
            </div>

            <div id="water" className="water">
              <svg viewBox="0 0 560 20" className="water_wave water_wave_front">
                <use xlinkHref="#wave"></use>
              </svg>
            </div>
          </div>
        </div>
      </PaymentSectionLayout>
      {type !== PAYMENT_TYPE.SPLIT_AMOUNT && !allPaid ? (
        <PayOther paymentInfo={paymentInfo} />
      ) : null}
      <ShareQrCodeContainer
        onClick={() => {
          handleOpen();
        }}
      >
        <QrIcon name="qr" /> {t('splitBillWaitingShareQrCode')}
      </ShareQrCodeContainer>
    </Wrapper>
  );
};

export default SplitBillWaiting;
